module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 121
// module chunks = 0